export interface Feature {
  icon: string;
  name: string;
  title: string;
  description: string;
  topic: string;
}

export const FEATURES: Feature[] = [
  {
    icon: '🎙️',
    name: 'NovaSonic',
    title: 'Speech to Speech Agentic AI',
    description: 'Experience natural, human-like voice conversations powered by Amazon\'s latest speech AI technology',
    topic: 'Introduction to Speech to Speech capabilities and natural conversation flow'
  },
  {
    icon: '🎯',
    name: 'PredictiveInsights',
    title: 'Predictive Insights',
    description: 'Transform every customer interaction into revenue opportunities with AI-powered predictive insights',
    topic: 'How predictive insights learns from interactions and provides cross-sell/upsell recommendations'
  },
  {
    icon: '♾️',
    name: 'SelfService',
    title: 'Agentic Self-Service',
    description: 'Scale customer service infinitely without added costs using AI that can reason, plan, and act autonomously',
    topic: 'Demonstration of agentic AI handling complex customer scenarios'
  },
  {
    icon: '📊',
    name: 'ManagerAssistance',
    title: 'AI-Powered Manager Assistance',
    description: 'Manage AI and human agents side-by-side with conversational operations management',
    topic: 'How managers use natural language to optimize operations'
  },
  {
    icon: '🤝',
    name: 'HumanAI',
    title: 'Agentic Assistance for Agents',
    description: 'Empower human agents with AI that handles repetitive tasks while they focus on complex cases',
    topic: 'How AI brings humans in at the right time for judgment and empathy'
  },
  {
    icon: '🔧',
    name: 'BOA',
    title: 'Back-Office Automation',
    description: 'Automate repetitive processes end-to-end, from refunds to inventory updates',
    topic: 'How back-office teams shift from data entry to handling complex cases'
  }
];
